import { CircularProgress } from '@material-ui/core';
import moment from 'moment';
import React, { useEffect, useState } from 'react';

import { getReportLastUpdateTimestamp } from '~/src/dash/apiV2/reporting/preview';
import { mapStringToReportTypeID } from '~/src/dash/apiV2/reporting/reportTypes';
import { spacingV2 } from '~/src/dash/components/layout/common';
import { Col, Cols, Text } from '~/src/dash/publicaUI';
import {
  LoadingState,
  LoadingStateHasData,
  LoadingStateLoading,
  LoadingStateNoData,
} from '~/src/dash/utils/loading-states';
import { useReportPreviewStore } from '~/src/dash/views/reporting/Preview/context';

export const LatestDataTimestamp = () => {
  const { isReadAuthorized, publisher, queryParams } = useReportPreviewStore();
  const reportTypeID = mapStringToReportTypeID[queryParams?.reporttype];

  const [error, setError] = useState<any>(null);
  const [loadState, setLoadState] = useState<LoadingState>(LoadingStateLoading);
  const [lastestDataTimestamp, setLastestDataTimestamp] = useState<moment.Moment | null>(null);

  const getTimestampText = () => {
    if (loadState === LoadingStateLoading)
      return (
        <>
          Loading Data...
          <CircularProgress size={14} />
        </>
      );
    if (error) return 'Failed to load last updated timestamp for the report';
    return lastestDataTimestamp
      ? `${lastestDataTimestamp?.format(
          'MMMM Do YYYY, h:mm:ss a',
        )} [timezone: ${queryParams?.timezone}]`
      : 'N/A';
  };

  const fetchLastestDataTimestamp = () => {
    getReportLastUpdateTimestamp(publisher.ID, reportTypeID)
      .then((timestamp: number) => {
        setLoadState(LoadingStateHasData);
        if (timestamp && timestamp > 0) {
          setLastestDataTimestamp(moment(timestamp * 1000).tz(queryParams?.timezone));
        }
      })
      .catch((err) => {
        setError(err);
        setLoadState(LoadingStateNoData);
      });
  };

  // refetch the timestamp when publisher or reportType changes
  useEffect(() => {
    // do not fetch if we dont have all the information
    if (publisher && reportTypeID && isReadAuthorized) {
      fetchLastestDataTimestamp();
    }
  }, [publisher?.ID, reportTypeID]);

  return (
    <Cols wrap gap={spacingV2.extraSmall} style={{ alignItems: 'center' }}>
      <Col>
        <Text sizeV2 small muted>
          Latest hour of data available:
        </Text>
      </Col>
      <Col>
        <Text sizeV2 small>
          {getTimestampText()}
        </Text>
      </Col>
    </Cols>
  );
};
